module.exports = __webpack_public_path__ + "img/EGP.49afb234.svg";